import {
  List,
  Datagrid,
  ChipField,
  TextField,
  DateField,
  BooleanField,
  NumberField,
  Show,
  SimpleShowLayout,
} from 'react-admin'

// <List filters={postFilters}>
// const postFilters = [
//     <TextInput source='q' label='Search' alwaysOn />,
//     <ReferenceInput source='userId' label='User' reference='users' />,
// ]

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const JobList = () => (
  <List queryOptions={{ meta: { isMy: true } }}>
    <Datagrid bulkActionButtons={false} rowClick="show">
      <ChipField source="type" />
      <ChipField source="status" />
      <DateField source="scheduledAt" />
      {/* <BooleanField source="isRecurring" /> */}
      {/* <NumberField source="recurringIntervalInMinutes" /> */}
      <DateField source="startsAt" />
      <ChipField source="period" />
    </Datagrid>
  </List>
)

export const JobShow = () => (
  <Show queryOptions={{ meta: { isMy: true } }}>
    <SimpleShowLayout>
      <ChipField source="type" />
      <ChipField source="status" />
      <TextField source="error" />
      <DateField source="scheduledAt" />
      {/* <BooleanField source="isRecurring" /> */}
      {/* <NumberField source="recurringIntervalInMinutes" /> */}
      <DateField source="startsAt" />
      <ChipField source="period" />
      <TextField source="parameters" />
    </SimpleShowLayout>
  </Show>
)
